import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get Consul properties from API as a middleware.
 * 
 * @returns {Promise<Object>}
 */
export function getConsul() {
  return axios.get(`${apiUrl}/consul`);
}